import {RouteComponentProps} from "react-router-dom";
import React from 'react';
import Box from "@amzn/awsui-components-react/polaris/box";
import MappingsPanel from "./MappingsPanel";

type MappingsPageProps = RouteComponentProps

const MappingsPage: React.FC<MappingsPageProps> = (props) => {
    return (
        <div id='manage-mappings'>
            <Box variant='h1'> Manage Mappings</Box>
            <MappingsPanel history={props.history}/>
        </div>
    )
}

export default MappingsPage
